import { checkoutCustomerRegistration } from './checkoutCustomerRegistration';
import { paymentLink } from './paymentLink';

const esCR = {
  ...checkoutCustomerRegistration,
  ...paymentLink,
};

export default esCR;
